export const templatesViewSx = {
  templateNameGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },
  templateName: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#fff',
    textTransform: 'uppercase',
  },
  configWrapper: {
    minHeight: 115,
    p: 3,
    border: '1px solid rgb(80 85 89)',
    background: '#212327',
    buttonWrapper: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
    },
  },
  fields: {
    mb: 2,
    fontSize: 17,
    '@media (min-width: 1920px)': {
      fontSize: '1.6rem',
    },
  },
  fullConfig: {
    wrapper: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      bgcolor: '#212327',
      color: '#fff',
      p: 4,
      width: '60vw',
      maxHeight: '80vh',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      closeButton: {
        color: '#fff',
        fontSize: '1.5rem',
        minWidth: 'auto',
        padding: 0,
      },
      divider: {
        mt: 1,
        mb: 4,
        border: '1px solid',
        borderColor: '#ffffff',
      },
    },
    fieldsSection: {
      overflowY: 'auto',
      flexGrow: 1,
      fieldsWrapper: { px: 3, mt: 2 },
    },
    footer: {
      mt: 3,
      display: 'flex',
      justifyContent: 'flex-end',
      flexShrink: 1,
    },
  },
};
